import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    accordion: {
      height: '40px',
      '& .MuiAccordion-root': {
        padding: 0,
      },
      '& .MuiPaper-elevation1': {
        boxShadow: '#F0F0F0 0px 1px 3px 0px, #F0F0F0 0px 0px 0px 1px',
      },
    },
    accordionSummary: {
      minHeight: '40px',
      '& .MuiAccordionSummary-content': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'nowrap',
        margin: 0,
        marginLeft: theme.spacing(2),
        position: 'relative',
        '&::before': {
          content: '"\\2022"',
          position: 'absolute',
          left: -15,
        },
      },
      '&.Mui-expanded': {
        minHeight: '40px',
      },
      '& .MuiIconButton-root': {
        padding: '0 1rem',
      },
    },
    accordionDetails: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
    },

    accordionDetailsItem: {
      fontWeight: 400,
      fontSize: '1.2rem',
      textAlign: 'right',
    },

    label: {
      fontWeight: 600,
      whiteSpace: 'nowrap',
      fontSize: '1.2rem',
      position: 'relative',
    },
    title: {
      fontWeight: 400,
      fontSize: '1.2rem',
    },
  }),
)
